import * as React from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

function SvgComponent(props: SvgIconProps) {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.40799 0.807424C8.16725 0.620182 7.83014 0.620182 7.5894 0.807424L1.5894 5.47409C1.42701 5.60039 1.33203 5.7946 1.33203 6.00033V13.3337C1.33203 13.8641 1.54274 14.3728 1.91782 14.7479C2.29289 15.1229 2.8016 15.3337 3.33203 15.3337H5.9987H9.9987H12.6654C13.1958 15.3337 13.7045 15.1229 14.0796 14.7479C14.4547 14.3728 14.6654 13.8641 14.6654 13.3337V6.00033C14.6654 5.7946 14.5704 5.60039 14.408 5.47409L8.40799 0.807424ZM10.6654 14.0003H12.6654C12.8422 14.0003 13.0117 13.9301 13.1368 13.8051C13.2618 13.68 13.332 13.5105 13.332 13.3337V6.32638L7.9987 2.17823L2.66536 6.32638V13.3337C2.66536 13.5105 2.7356 13.68 2.86063 13.8051C2.98565 13.9301 3.15522 14.0003 3.33203 14.0003H5.33203V8.00033C5.33203 7.63214 5.63051 7.33366 5.9987 7.33366H9.9987C10.3669 7.33366 10.6654 7.63214 10.6654 8.00033V14.0003ZM6.66536 14.0003V8.66699H9.33203V14.0003H6.66536Z"
        fill="#CFD4DA"
      />
    </svg>
  );
}

const HouseDetailIcon = React.memo(SvgComponent);
export default HouseDetailIcon;
